import { useEffect } from 'react';
const PIXEL_ID = '1677400554089957';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

/**
 * Meta Pixel (Facebook Pixel) loader.
 * Injects the official Meta Pixel base code and fires a PageView.
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!window.fbq) {
      /* eslint-disable */
      ;
      (function (f: any, b: Document, e: string, v: string) {
        let n: any, t: any, s: any;
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */

      window.fbq('init', PIXEL_ID);
    }
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-39" data-mp="13ihywy243x5h">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-40" data-mp="13irmyg3lju8j" />
    </noscript>;
}